module.exports = __webpack_public_path__ + "static/img05-0b5cc7afd485ec38275fcf660f45e996.jpg";